import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { FormattedMessage, useIntl } from 'react-intl';

import { formatCurrency } from '../../../../components/FormattedCurrency';
import { CurrentUser } from '../../../../core-types';
import {
  Container,
  Button,
  Flex,
  Text,
  Box,
  H1
} from '@urbaninfrastructure/react-ui-kit';
import { wallet } from '../messages';
import { makeStyles, createStyles } from '@material-ui/core';

type Props = {
  currentUser: CurrentUser;
  handleContinuelick: () => void;
};

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      color: 'green',
      width: '2.5em',
      height: '2.5em',
      marginBottom: '1em'
    }
  })
);

export const TopUpWalletResult = ({
  currentUser,
  handleContinuelick
}: Props) => {
  const intl = useIntl();
  const classes = useStyles();

  if (!currentUser) {
    return null;
  }

  return (
    <Container variant="narrow" textAlign="center">
      <Box maxWidth="600px">
        <CheckIcon className={classes.root} />
        <Box>
          <H1 typoStyle="lg">
            <FormattedMessage {...wallet.topup_sucsessfull} />
          </H1>
        </Box>
        <Text mb="xs">
          <FormattedMessage
            {...wallet.wallet_balance}
            values={{
              0: formatCurrency({
                value: currentUser?.wallet?.balance || 0,
                precision: 2,
                intl
              })
            }}
          />
        </Text>
        <Button
          shape="cool"
          variant="primary"
          mb="xs"
          mt="xs"
          onClick={() => {
            handleContinuelick();
          }}
        >
          {' '}
          <Text>
            <FormattedMessage {...wallet.continue} />
          </Text>
        </Button>
      </Box>
    </Container>
  );
};

export function TopUpWalletResultStep({
  currentUser,
  handleContinuelick
}: Props) {
  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <TopUpWalletResult
        handleContinuelick={handleContinuelick}
        currentUser={currentUser}
      />
    </Flex>
  );
}
